import React from 'react';
import intl from "react-intl-universal";
import {observer} from 'mobx-react-lite'
import classNames from "classnames";
import {useRootStore, useUserState} from "@stores/AppStateContext";

import {Tooltip} from "../../components/Tooltip"
import {MenuIcon} from "../../components/icons/MenuIcon";
import {LogoIcon} from "../../components/icons/LogoIcon";
import {ProfileIcon} from "../RightMenu/ProfileIcon";

import {screenSizeProvider} from "@stores/ScreenSizeProvider";


import '../HeaderMenu/header-menu.css';


export const HeaderWithoutWorkspace = observer(() => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const isMobile = screenSizeProvider.view !== 'desktop';
    const isAdmin = userState!.isCurrentUserAdmin
    return (
        <header className={classNames({
            "hm-WithoutWorkspace": true,
            "theme-dark": isMobile
        })}>
            <div className='hm_left-part'>
                {isAdmin ?
                    <Tooltip title={intl.get('tooltip.setting.menu').d("Settings & Tools")} isInBox={false}>
                        <MenuIcon size={24} className={'hm_hamburger-box'} onClick={() => {
                            rootStore.view.openPageByName('settings');
                        }}/>
                    </Tooltip> : null}
                <LogoIcon className='hm-logo_main' size={null}/>
            </div>
            <ProfileIcon
                className="hm_button"
                size={24}
                onlyLogout={true}
            />
        </header>
    );
});
